import { render, staticRenderFns } from "./About.vue?vue&type=template&id=6f9213d4"
import script from "./About.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./About.vue?vue&type=script&charset=utf-8&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports